"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const config_1 = require("./config");
const ROOT_URL = process.env.NODE_ENV !== "prod" ? config_1.dev.url : config_1.prod.url;
class API {
    constructor() {
        this.token = null;
        this.loggedIn = false;
    }
    clear() {
        this.token = null;
        this.loggedIn = false;
    }
    logout() {
        return this.getToken(false, true)
            .then(token => {
            if (!token)
                return;
            const config = {
                baseURL: ROOT_URL,
                url: '/logout',
                method: 'post',
                headers: {
                    'X-Token': token,
                }
            };
            return (0, axios_1.default)(config);
        })
            .finally(this.clear);
    }
    setToken(token) {
        this.token = token;
        this.loggedIn = true;
    }
    login(email, password) {
        this.token = null;
        this.loggedIn = false;
        const config = {
            url: '/login',
            method: 'post',
            baseURL: ROOT_URL,
            data: {
                email,
                password
            }
        };
        return this.getToken()
            .then((token) => {
            if (!config.headers)
                config.headers = {};
            config.headers['X-Token'] = token;
            return (0, axios_1.default)(config);
        })
            .then((response) => {
            this.token = response.data.ID;
            this.loggedIn = true;
            return response.data;
        })
            .catch((error) => {
            let returnError = error;
            if (error.response) {
                returnError = typeof error.response.data === 'object' ? error.response.data.error : error.response;
            }
            throw returnError;
        });
    }
    http(config, dontSaveToken = false) {
        config.baseURL = ROOT_URL;
        if (config.data && typeof config.data === 'object') {
            //Remove any underscores
            config.data = Object.keys(config.data)
                .filter(key => key.substr(0, 1) !== '_')
                .reduce((result, current) => {
                result[current] = config.data[current];
                return result;
            }, {});
        }
        return this.getToken(false, dontSaveToken)
            .then(token => {
            if (!config.headers)
                config.headers = {};
            config.headers['x-api-key'] = token;
            return (0, axios_1.default)(config);
        })
            .then(response => {
            return response.data;
        })
            .catch(error => {
            if (error.response && error.response.status === 401) {
                this.logout();
                throw error.response;
            }
            let returnError = error;
            if (error.response) {
                returnError = typeof error.response.data === 'object' ? error.response.data.error : error.response;
            }
            throw returnError;
        });
    }
    getToken(force = false, dontSaveToken = false) {
        return new Promise((resolve, reject) => {
            if (this.token && !force) {
                return resolve(this.token);
            }
            axios_1.default.get(`${ROOT_URL}/tokens/temp`)
                .then(response => {
                if (!dontSaveToken) {
                    this.token = response.data.ID;
                }
                resolve(response.data.ID);
            })
                .catch(reject);
        });
    }
}
exports.default = API;
